import { type ReactNode } from "react";
import { UnlocksContext, useGetUnlocks } from "./context.ts";

export function UnlocksFetcher(props: { children: ReactNode }) {
  const result = useGetUnlocks({ gameCode: "greathelm" });
  return <UnlocksContext value={result}>{props.children}</UnlocksContext>;
}
